<template>
    <div  class="flex flex-col w-full h-auto px-4 mb-12">
        <!-- Header -->
        <div class="flex w-full h-auto justify-center items-center mb-3">
            <span class="Helvetica text-2xl font-bold text-blue-500 justify-center normal-case">Shipping Information</span>
        </div>
         <div v-if="currentUser && currentUser.type && currentUser.type == 'Accountant'" class="px-6 my-5 flex justify-center items-center"> 
            <button @click="activate('cancelled')" :class="{ active : active_el == 'cancelled' }" class="bg-red-500 shadow text-white px-6 py-2 rounded font-medium mx-3 hover:bg-red-600 transition duration-200 each-in-out  inline-block mr-2 mb-2">
                <i class="material-icons icon-acount align-sub w-4 h-4 mr-2">clear</i> Cancelled
            </button>
            <button @click="activate('reprogrammed')" :class="{ active : active_el == 'reprogrammed' }"  class="bg-yellow-500 shadow text-white px-6 py-2 rounded font-medium mx-3 hover:bg-yellow-600 transition duration-200 each-in-out  inline-block mr-2 mb-2">
                <i class="material-icons  icon-acount align-sub w-4 h-4 mr-2">event_note</i> Reprogram
            </button>
            <button @click="activate('received')" :class="{ active : active_el == 'received' }" class="bg-green-500 shadow text-white px-6 py-2 rounded font-medium mx-3 hover:bg-green-600 transition duration-200 each-in-out  mr-2 mb-2">
                <i class="material-icons icon-acount align-sub w-4 h-4 mr-2">beenhere</i> Received
            </button>
        </div>   
        <div v-else >
            <!-- **********Shipping info*********** -->
                <div class="w-full">
                        <div class="space-x-2 w-full shadow-xs mt-1 mb-1 rounded-lg border border-gray-500">
                            <div class="flex w-full justify-between items-center h-auto p-6 ">
                                <div class="flex w-full">
                                    <span class="rounded-full h-12 w-12 bg-gray-200">
                                        <i class="material-icons p-3 text-blue-500">local_mall</i>
                                    </span>
                                    <div class="ml-3 w-full p-2">
                                        <div class="w-full flex text-base font-semibold text-gray-600">
                                            <p class="w-1/2">Shipping Informations</p>
                                        </div>
                                        <div class="bg-white rounded-lg p-6 pb-0">
                                            <div class="grid lg:grid-cols-2 gap-6">
                                              <div v-if="currentUser.type=='Admin' || currentUser.type=='Administrateur' || currentUser.type=='StockManager'" class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                        <p>
                                                            <label for="shippdate" class="bg-white text-gray-700 px-1">Shipping date
                                                                <span :class="$colors.required">*</span></label>
                                                        </p>
                                                    </div>
                                                    <p>
                                                        <input id="shippdate" :disabled="['received','paid','processed'].indexOf(item.status) === -1?false:true"  type="date"  v-model="item.date" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                                                    </p>
                                                </div>
                                                
                                                <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                        <p>
                                                            <label for="status" class="bg-white text-gray-700 px-1">Status <span :class="$colors.required">*</span>
                                                            </label>
                                                        </p>
                                                    </div>
                                                    <p>
                                                        <select @change="onChangeStatus($event)"  :style="colorStatus(item.status)" :disabled="item.refund && item.status && item.status=='received'" v-model="item.status" class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                                            <option class="bg-white" selected :value="null"> Status </option>
                                                            <option class="bg-white text-gray-600" v-for="(value, index) in statusShipp" :key="index" :value="value">
                                                                {{ value }}
                                                            </option>
                                                        </select>
                                                    </p>
                                                </div>
                                                
                                                <div class="border h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                        <p>
                                                        <label for="category" class="bg-white text-gray-700 px-1">Zone shipping <span :class="$colors.required">*</span></label>
                                                        </p>
                                                    </div>
                                                    <p>
                                                    <select :disabled="currentUser.type=='Courier'" id="type"  v-model="currentzone" class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                                        <option selected disabled :value="null">zone name</option>
                                                        <option v-for="(zone,index) in zones" :key="index" :value="zone._id">
                                                            {{ zone.name }}
                                                        </option>
                                                    </select>
                                                    </p>
                                                </div>
                                                <div class="border h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                        <p>
                                                        <label for="courier" class="bg-white text-gray-700 px-1">Courier <span :class="$colors.required">*</span></label>
                                                        </p>
                                                    </div>
                                                    <p>
                                                    <v-select v-bind:class="{ disabled: currentUser.type=='Courier' }" label="fullName" v-model="item.courier" :options="couriers" ></v-select>
                                                    </p>
                                                </div>
                                                
                                                <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">                    
                                                    <p>
                                                        <label for="customerAddress" class="bg-white text-gray-700 px-1" >Address shipping<span :class="$colors.required">*</span></label>
                                                    </p>
                                                    </div>
                                                    <p>
                                                    <textarea id="customerAddress" type="text" v-model="item.address"
                                                        class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                                                    </p>
                                                </div>
                                                
                                                <div v-if="item.type!='normal'" class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                        <p>
                                                            <label for="type" class="bg-white text-gray-700 px-1">Type <span :class="$colors.required">*</span>
                                                            </label>
                                                        </p>
                                                    </div>
                                                    <p>
                                                        <select  v-model="item.type" class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                                            <option class="bg-white" selected :value="null"> Type </option>
                                                            <option class="bg-white text-gray-600" v-for="(value, index) in typesShipp" :key="index" :value="value">
                                                                {{ value }}
                                                            </option>
                                                        </select>
                                                    </p>
                                                </div>
                                                <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">                    
                                                    <p>
                                                        <label for="customerAddress" class="bg-white text-gray-700 px-1" >Comment order<span :class="$colors.required">*</span></label>
                                                    </p>
                                                    </div>
                                                    <p>
                                                    <textarea id="customerAddress" type="text" v-model="item.order.comment"
                                                        class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                        </div>     
                                    </div>    
                                </div>    
                            </div>
                        </div>
                        
                </div>
                
            <!-- **************/Shipping info****************-->
            <!--*******************  Product change ***************************************-->
            <!-- <div  v-if="item.type=='change'" class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                <div class="flex w-full mt-1">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-blue-400">local_mall</i>
                    </span>
                    <div class="ml-5 w-full pb-4">
                        <div class="text-base mt-1 font-semibold text-gray-600 pb-10">Products change</div>
                        <div class="w-full space-y-4">
                            <div class="w-full">
                                <table class="min-w-full w-full">
                                    <thead class="text-white">
                                        <tr class="bg-blue-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                            <th class="p-2 justify-center">Image</th>
                                            <th class="p-2 justify-center">Name</th>
                                            <th class="p-2 justify-center">Quantity</th>
                                            <th class="p-2 justify-center">Quantity Returned</th>
                                        </tr>
                                    </thead>
                                    <tbody class="flex-1 sm:flex-none">
                                        <tr v-for="(it,index) in item.order.details" :key="index" class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2">
                                                <div> <img :alt="it.product.name" :src="it.product.picture" class="h-16 w-16 rounded-md mx-auto" /> </div>
                                            </td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.product.name }}</b></td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.quantity }}</b></td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                                                    <table class="min-w-full">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-blue-500 tracking-wider">Ok/Good</th>
                                                            <th  v-if="CheckQteDefecteuseexist" class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-blue-500 tracking-wider">Defective</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="bg-white">
                                                        <tr>
                                                            <td class="px-6 py-2 border whitespace-no-wrap"><div class="flex items-center">
                                                                <input id="Defective" :disabled="CheckQteDefecteuseexist" type="number" :max="it.quantity" min="0"  v-model="it.product.qteChange" class="py-2 border-4 border-light-blue-500 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
                                                            </div>
                                                            </td>
                                                            <td  v-if="CheckQteDefecteuseexist" class="px-6 py-2 border whitespace-no-wrap"><div class="flex items-center"> {{ it.quantity-it.product.qteChange }}</div></td>    
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!--  end product change --> 
        </div> 
          <!--*******************  Product returned ***************************************-->
            <div  v-if="item.status=='cancelled' || active_el == 'cancelled'" :id="'return-'+item._id" class="animate-show-tab flex w-full justify-between shadow-xs items-center h-auto px-6  mb-5 rounded-lg">
                <div class="flex w-full mt-1">
               
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-blue-400">local_mall</i>
                    </span>
                    <div class="ml-5 w-full pb-4">
                        <div class="text-base mt-1 font-semibold text-gray-800 pb-5">Products returned</div>
                        <div class="w-full space-y-4">
                            <div class="w-full">
                                <table class="min-w-full w-full">
                                    <thead class="text-white">
                                        <tr class="bg-blue-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                            <th class="p-2 justify-center">Image</th>
                                            <th class="p-2 justify-center">Name</th>
                                            <th class="p-2 justify-center">Quantity Sent</th>
                                            <th class="p-2 justify-center">Quantity Returned</th>
                                        </tr>
                                    </thead>
                                    <tbody class="flex-1 sm:flex-none">
                                        <tr v-for="(it,index) in item.order.details" :key="index" class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2">
                                                <div> <img :alt="it.product.name" :src="it.product.picture" class="h-16 w-16 rounded-md mx-auto" /> </div>
                                            </td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.product.name }}</b></td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                                                    <span>{{it.quantity}}</span>
                                            </td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                                                    <table class="min-w-full">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center bg-gray-200 px-6 py-1 border border-gray-300 text-left leading-4 text-blue-500 tracking-wider">Ok/Good</th>
                                                            <th   class="text-center bg-gray-200 px-6 py-1 border border-gray-300 text-left leading-4 text-blue-500 tracking-wider">Defective</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="bg-white">
                                                        <tr>
                                                            <td class="px-6 py-2 border whitespace-no-wrap"><div class="flex items-center">
                                                                <input id="Defective" @input="handleUpdate($event, index)" :disabled="CheckQteReturnedexist" type="number" :max="it.quantity" min="0"  v-model="it.product.qteChange" class="py-2 border-4 border-light-blue-500 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
                                                            </div>
                                                            </td>
                                                            
                                                            <td  class="px-6 py-4 border whitespace-no-wrap text-center text-red-600 bg-red-200 font-bold">{{ it.quantity-it.product.qteChange }}</td>   
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">                    
                                <p>
                                    <label for="customerAddress" class="bg-white text-gray-700 px-1" >Reason of cancelation </label>
                                </p>
                                </div>
                                <p>
                                <textarea id="customerAddress" placeholder="Reason ...." type="text" v-model="item.comment"
                                    class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                                </p>
                            </div>    
                        </div>
                    </div>
                </div>
            
            </div>
            <div  v-if="item.status!='cancelled' && active_el!='cancelled'" class="flex border border-gray-500  mt-4 shadow-xs rounded-lg  mb-3">
                <div class="flex justify-between pb-0 w-full h-auto p-4 rounded-lg border-gray-100" >
                    <div class="flex w-full">
                    <span class="rounded-full h-12 w-12 bg-gray-100">
                        <i class="material-icons p-3 text-blue-400 ">local_mall</i>
                    </span>
                    <div class="ml-1 w-full p-2">
                        <div class="flex items-center ">
                            <div class="text-base font-semibold text-gray-700"> Products Order  </div>
                            <button  v-tooltip="{classes:['received','paid','processed'].indexOf(item.status) === -1?'isProcessed':'',content:'Tu peux pas modifier, car cette order est deja '+item.status}" v-if="currentUser && currentUser.type && currentUser.type != 'Accountant'"  @click="ChangeQuantityOrder(item)" class="btn ml-auto btn-primary bg-blue-500  mr-2 text-white py-2 px-4 items-center focus:outline-none btn-marketing">
                                <svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide block mx-auto inline-block align-middle"><path d="M17 2l4 4-4 4"></path><path d="M3 11v-1a4 4 0 014-4h14"></path><path d="M7 22l-4-4 4-4"></path><path d="M21 13v1a4 4 0 01-4 4H3"></path></svg> 
                                Change quantity Or TotalPrice Or products
                            </button>
                        </div>
                        <div class="w-full mt-4">
                        <table class="min-w-full leading-normal">
                            <thead>
                            <tr> <th class="px-5 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider">Image</th>
                                <th class="px-5 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider">Product</th>
                                <th class="px-5 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider">Quantity</th>
                                <th class="px-5 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 capitalize tracking-wider">Price</th>
                            </tr>
                            </thead>
                            <tbody
                            v-for="(it, index) in item.order.details" :key="it._id">
                            <tr :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                                <td class="px-5 py-2 border-b border-gray-200 bg-white text-sm">
                                <span class="flex text-gray-700 capitalize whitespace-no-wrap"><span class="mt-1"><img :src="it.product.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'" class="h-30 rounded-md mx-auto"></span></span>
                                </td>
                                <td class="px-5 py-2 border-b border-gray-200 bg-white text-sm">
                                <span class="flex text-gray-700 capitalize whitespace-no-wrap"><span class="mt-1">{{ it.product.name }}</span></span>
                                </td>
                                <td
                                class="px-5 py-2 border-b border-gray-200 bg-white text-xs"
                                >
                                <p class="text-gray-700 ml-6 whitespace-no-wrap">
                                    <span class="font-semibold"
                                    >{{ it.quantity }}
                                    </span>
                                </p>
                                </td>
                                <td
                                class="px-5 py-2 border-b border-gray-200 bg-white text-xs"
                                >
                                <span
                                    class="justify-center text-xs text-center pl-2 pr-2 py-1 rounded-full text-gray-700"
                                >
                                    <span
                                    class="text-gray-800 font-semibold text-xs ml-1"
                                    >
                                    {{ it.unitPrice }}
                                    </span>
                               
                                </span>
                                </td>
                            </tr>
                            </tbody>
                            <tbody><tr><td colspan="5" class="px-6 text-right py-2 whitespace-no-wrap border-gray-200"><div class="text-xs leading-5 capitalize px-2 rounded-full font-bold text-gray-900">  totalPrice: {{item.order.totalPrice}} </div></td></tr></tbody>
                        </table>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <!--  end product returned -->    
            <!--reprogram date-->
            <div v-if="currentUser && currentUser.type && currentUser.type == 'Accountant' && (active_el == 'reprogrammed' || item.status=='reprogrammed')" class="mb-20">
               <div class="intro-y block flex justify-center items-center h-10">
                   <h2 class="text-lg font-medium truncate mr-5">Reprogram date :</h2>
                   <div class="relative text-gray-700 dark:text-gray-300">
                       <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar w-4 h-4 z-10 absolute my-auto inset-y-0 ml-3 left-0 w-4 h-4 z-10 absolute my-auto inset-y-0 ml-3 left-0"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                        <datetime-v2 :min-datetime="$moment(Date.now()).format('yyyy-MM-DD')" v-model="item.date"
                                    placeholder="Reprogram date ..." input-class="form-control w-56 w-full px-3 py-2 pl-10 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline" ></datetime-v2> 
                    </div>
               </div>
            </div>
            <!-- end reprogram date-->
             <!--received status-->
             <div  v-if="currentUser && currentUser.type && currentUser.type == 'Accountant' && (active_el == 'received' || item.status=='received')" class="mb-20">
              <div  class="flex justify-center items-center">
                <div class="w-2 h-2 bg-blue-600 dark:bg-blue-600 rounded-full mr-3"></div>
                <span class="truncate mr-3">Change status to :</span>
                <div class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"></div>
                <span class="font-medium text-green-700">Received</span>
              </div>
            </div>
              <!--end received status-->

            <div v-if="currentUser && currentUser.type && currentUser.type != 'Accountant'"  class="blue tagged tex2jax_ignore x-rem clc-jobs-multi py-4" style="margin-bottom: 33px;">
                    <div class="header d-flex">
                        <span class="flex--item fl1"> <strong>Change in order of </strong> cases </span>
                        <span class="header-icon-right flex--item"> 
                            <svg class="svg-icon iconHome fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2.033 16.01c.564-1.789 1.632-3.932 1.821-4.474.273-.787-.211-1.136-1.74.209l-.34-.64c1.744-1.897 5.335-2.326 4.113.613-.763 1.835-1.309 3.074-1.621 4.03-.455 1.393.694.828 1.819-.211.153.25.203.331.356.619-2.498 2.378-5.271 2.588-4.408-.146zm4.742-8.169c-.532.453-1.32.443-1.761-.022-.441-.465-.367-1.208.164-1.661.532-.453 1.32-.442 1.761.022.439.466.367 1.209-.164 1.661z"/></svg>
                        </span>
                    </div>
                    <div class="middle">
                        <div class="voyage-info">
                            <div class="segments">
                                <div class="segment departure">
                                    <time class="fz-10" style="color:#dbb010">Queued</time>
                                </div> 
                                <div class="divider"></div> 
                                <!-- <div class="segment adaptive duree">
                                    <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                </div>  -->
                                <div class="divider adaptive"></div> 
                                <div class="segment destination">
                                    <time class="fz-10" style="color:#1073db">Prepared</time> 
                                </div>
                            </div>
                        </div>
                        <div  class="voyage-info">
                            <div class="segments">
                                <div class="segment departure">
                                    <time class="fz-10" style="color:#1073db">Prepared</time>
                                </div> 
                                <div class="divider"></div> 
                                <!-- <div class="segment adaptive duree">
                                    <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                </div>  -->
                                <div class="divider adaptive"></div> 
                                <div class="segment destination">
                                    <time class="fz-10" style="color:#cf5d26">Shipped</time> 
                                </div>
                            </div>
                        </div>
                        <div v-if="toggle" class="voyage-info">
                            <div class="segments">
                                <div class="segment departure">
                                    <time class="fz-10" style="color:#cf5d26">Shipped</time>
                                </div> 
                                <div class="divider"></div> 
                                <!-- <div class="segment adaptive duree">
                                    <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                </div>  -->
                                <div class="divider adaptive"></div> 
                                <div class="segment destination">
                                    <time class="fz-10" style="color:black">Reprogrammed</time> 
                                </div>
                            </div>
                        </div>
                        <div v-if="toggle" class="voyage-info">
                            <div class="segments">
                                <div class="segment departure">
                                    <time class="fz-10" style="color:black">Reprogrammed</time>
                                </div> 
                                <div class="divider"></div> 
                                <!-- <div class="segment adaptive duree">
                                    <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                </div>  -->
                                <div class="divider adaptive"></div> 
                                <div class="segment destination">
                                    <time class="fz-10" style="color:#cf5d26">Shipped</time> 
                                </div>
                            </div>
                        </div>
                        <div v-if="toggle" class="voyage-info">
                            <div class="segments">
                                <div class="segment departure">
                                    <time class="fz-10" style="color:#cf5d26">Shipped</time>
                                </div> 
                                <div class="divider"></div> 
                                <!-- <div class="segment adaptive duree">
                                    <span class="bus">  <i style="font-size: 16px;vertical-align: sub;" class="material-icons">access_time</i> Shipping date :{{$moment(Date.now()).format('yyyy-MM-DD')}} </span>
                                </div>  -->
                                <div class="divider adaptive"></div> 
                                <div class="segment destination">
                                    <time class="fz-10" style="color:#45a52e">Received</time> 
                                </div>
                            </div>
                        </div>
                        <div v-if="toggle" class="voyage-info">
                            <div class="segments">
                                <div class="segment departure">
                                    <time class="fz-10" style="color:#45a52e">Received</time>
                                </div> 
                                <div class="divider"></div> 
                                <!-- <div class="segment adaptive duree">
                                    <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                </div>  -->
                                <div class="divider adaptive"></div> 
                                <div class="segment destination">
                                    <time class="fz-10" style="color:rgb(181 16 183)">Paid</time> 
                                </div>
                            </div>
                        </div>
                        <div v-if="toggle" class="voyage-info">
                            <div class="segments">
                                <div class="segment departure">
                                    <time style="color:rgb(46 65 165);font-size: 10px;">(Prepared,Shipped,Reprogrammed)</time>
                                </div> 
                                <div class="divider"></div> 
                                <!-- <div class="segment adaptive duree">
                                    <span class="bus"><i  class="fa fa-clock-o"></i> Queued </span>
                                </div>  -->
                                <div class="divider adaptive"></div> 
                                <div class="segment destination">
                                    <time class="fz-10" style="color:red">Cancelled</time> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!toggle" class="q-absolute qu-textAlign--center qu-zIndex--base" style="box-sizing: border-box; position: absolute; width: 100%; height: 100px; bottom: 0px; background: rgba(0, 0, 0, 0) linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%) repeat scroll 0% 0%;" width="100%">
                        <div class="q-inlineFlex" style="box-sizing: border-box; display: inline-flex;">
                            <div class="q-relative" style="box-sizing: border-box; position: relative; bottom: -60px;">
                                <button @click="toggle = !toggle" class="q-click-wrapper qu-active--textDecoration--none qu-focus--textDecoration--none qu-borderRadius--pill qu-alignItems--center qu-justifyContent--center qu-whiteSpace--nowrap qu-userSelect--none qu-display--inline-flex qu-bg--gray_ultralight qu-tapHighlight--white qu-textAlign--center qu-cursor--pointer qu-hover--textDecoration--none ClickWrapper___StyledClickWrapperBox-zoqi4f-0 iyYUZT base___StyledClickWrapper-lx6eke-1 gCrsNT puppeteer_test_read_more_button " style="box-sizing: border-box; font: inherit; padding: 0px 15px; transition-property: box-shadow, background-color; transition-duration: 60ms; transition-timing-function: ease-out; height: 30px; min-width: 30px; position: relative; box-shadow: rgba(99, 100, 102, 0.2) 0px 0px 0px 1px inset; border-width: 0px; outline: currentcolor none medium; color: inherit;" role="button" type="button" tabindex="0">
                                    <div class="q-flex qu-alignItems--center qu-justifyContent--center" style="box-sizing: border-box; display: flex; max-width: 100%; transition-property: opacity; transition-duration: 60ms; transition-timing-function: ease-in-out;">
                                        <div class="q-text qu-display--inline-flex qu-alignItems--center qu-overflow--hidden puppeteer_test_button_text qu-medium qu-color--gray" style="box-sizing: border-box; font-size: 13px;">
                                            <div class="q-text qu-ellipsis qu-whiteSpace--nowrap" style="box-sizing: border-box; line-height: normal;">Continue Reading</div>
                                        </div>
                                        <span class="q-inlineBlock qu-width--16 qu-height--16 qu-ml--tiny qu-mr--n_tiny" style="box-sizing: border-box; display: inline-block; flex-shrink: 0; line-height: 16px;" width="16">
                                            <span class="CssComponent__CssInlineComponent-sc-1oskqb9-1 Icon___StyledCssInlineComponent-sc-11tmcw7-0  dvqCYw">
                                                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m5 8.5 7 7 7.005-7" class="icon_svg-stroke" stroke="#666" stroke-width="1.5" fill="none" stroke-linecap="round"></path></svg>
                                            </span>
                                        </span>
                                    </div>
                                </button>
                             </div>
                        </div>
                    </div>
                   
            </div>

            
       
    </div>        
</template>
<script>
export default {
    props: {
        config: { required: true, type: Object},
        item:{ default: [] },
        index:{ type: Number },
        currentUser:{ type: Object },
        statusShipp:{ type: Array }, 
        typesShipp:{ type: Array }, 
        zones:{ type: Array },    
        active_el:{ default: "" },
        CheckQteDefecteuseexist:{required:false},  
        CheckQteReturnedexist:{required:false},
        couriers:{ type: Array,default() {return []}},
    },
    data() {
        return {
           courier :[],
           currentzone:null,
           oldStatus:"",
           toggle: false
        }
    },
    async mounted() {
       this.currentzone=await this.item.zone?await this.item.zone._id:null;
      // if(this.currentUser.type!='Seller') await this.getCurrentCourierZone(this.item.zone);
       if (this.statusShipp.indexOf('processed') === -1) this.statusShipp.push('processed');
    //    if (this.item.refund) {
    //         let indexss = this.statusShipp.indexOf("paid");
    //         if (indexss > -1) this.statusShipp.splice(indexss, 1);
    //    }else{
    //        if (this.statusShipp.indexOf('paid') === -1) this.statusShipp.push('paid');
    //    }
       await this.CheckQteDefecteuse();
       await this.CheckQteReturned();
       this.getOldStatus();
    },   
    methods: {
    setSelected(courier) {
        console.log(courier)  
    },
     scrollTo(hash) {
       location.hash = "#return-" + hash;
    },
     handleUpdate(event, index) {
        if(event.target.value < event.target.min) {
           this.item.order.details[index].product.qteChange = event.target.min;
        }
        if(event.target.value > event.target.max) {
           this.item.order.details[index].product.qteChange = event.target.max;
        }
        
    },
    onChangeStatus(event){
        if(event.target.value === 'cancelled'){
            console.log('is scroll');
             this.scrollTo(this.item._id);
        }
      },
    getStatus(){
       this.active_el= this.$store.getters.getStatus;
    },
    getOldStatus(){
       this.getStatus();
       this.oldStatus=this.item.status;
    },
    activate: function (el) {
        if(this.active_el.length==0) console.log('el empty---------------',this.active_el)
        else console.log('el---------------',this.active_el)
        this.$emit('activate',el);
        this.item.status=el;
        // if(el==="reprogram") this.item.status="reprogrammed";
        // else  this.item.status=el;
        console.log('el--------------- 11111',this.active_el)
    },
    async getCurrentCourierZone(id){
        if(id){
            const filter = {
                type: 'Courier',
                zones:id._id   
            };
            const res = await this.$server.search("users",filter);
            if (res.content.results) {
                this.courier = res.content.results;
            } else this.courier = [];
         }else this.courier = [];
     },  
     async getCourierZone(event){
         this.item.courier=null;
        const filter = {
            type: 'Courier',
            zones:event.target.options[event.target.options.selectedIndex].value
        };
        const res = await this.$server.search("users",filter);
        if (res.content.results) {
            this.courier = res.content.results;
        } else this.courier = [];
     },
     CheckQteDefecteuse: function (val) {
        this.$emit('CheckQteDefecteuse',this.item);
     },
     CheckQteReturned: function (val) {
        this.$emit('CheckQteReturned',this.item);
     },
     ChangeQuantityOrder: function (data) {
       // if(!data.isProcessed) this.$emit('ChangeQuantityOrder',data);
        if(['received','paid','processed'].indexOf(data.status) === -1) this.$emit('ChangeQuantityOrder',data);
    },
     colorStatus(status) {
            switch (status) {
                case 'queued':
                    return "color: rgb(233 147 19); border-color: rgb(233 147 19);" 
                    break;
                case 'prepared':
                    return  "color:rgb(58 217 18); border-color: rgb(58 217 18);" 
                    break;
                case 'shipped':
                    return  "color:rgb(58 217 18); border-color: rgb(58 217 18);" 
                    break;
                case 'received':
                    return  "color:rgb(58 217 18); border-color: rgb(58 217 18);" 
                    break;
                 case 'paid':
                    return  "color:rgb(34, 150, 78); border-color: rgb(34, 150, 78);" 
                    break;  
                case 'refunded':
                    return  "color:rgb(150 15 227); border-color: rgb(150 15 227);" 
                    break;   
                case 'reprogrammed':
                            return  "color:rgb(10 10 10); border-color: rgb(10 10 10);" 
                     break;     
                case 'cancelled':
                    return "color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);" 
                    break;
            }
        },
    },
    computed: {
      formattedDate() {
        return this.$moment(this.item.date).format('yyyy-MM-DD');
      }, 
       formattedDateShipp() {
        return this.$moment(this.item.date).format('yyyy-MM-DD');
      },     
    },

}
</script>
<style scoped>
 .seller-select .vs__dropdown-toggle {
    border: none;
}
button.active{
    border: 3px solid black;
}
</style>